import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { of } from 'rxjs';
import { MegaSizeLimitViewModel } from '../../types/common';

@Injectable()
export class ConfigurationService {
    currentYear = new Date().getFullYear();
    private testingEnabled: string | null = null;
    private arrobaClaveEnabled: string | null = null;
    private versionEnvironment: string | null = null;

    private _limitsDocSize: MegaSizeLimitViewModel;
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getValue(key: string): Observable<string> {
        return this.http.get<string>(this.baseUrl + 'api/core/configuration/' + key).pipe();
    }

    getMegaSizeLimit(): Observable<MegaSizeLimitViewModel> {
        return this.http.get<MegaSizeLimitViewModel>(this.baseUrl + 'api/core/configuration/MegaSizeLimit').pipe();
    }

    getCASWebShowCASUrl(): Observable<string> {
        return this.http.get<string>(this.baseUrl + 'api/core/configuration/CASWebShowCASUrl').pipe();
    }

    getCASWebServerName(): Observable<string> {
        return this.http.get<string>(this.baseUrl + 'api/core/configuration/CASWebServerName').pipe();
    }

    getCASWebLoginUrl(): Observable<string> {
        return this.http.get<string>(this.baseUrl + 'api/core/configuration/CASWebLoginUrl').pipe();
    }

    getVersionNumber(): Observable<string> {
        return this.http.get<string>(this.baseUrl + 'api/core/configuration/VersionNumber').pipe();
    }

    getUrlVisorSIGPAC(): Observable<string> {
        return this.http.get<string>(this.baseUrl + 'api/core/configuration/UrlVisorSigpac').pipe();
    }

    getEnvironment(): Observable<string> {
        if (this.versionEnvironment !== null) {
            return of(this.versionEnvironment);
        }
        return this.http.get<string>(this.baseUrl + 'api/core/configuration/VersionEnvironment').pipe(
            tap(res => {
                this.versionEnvironment = res;
            }),
        );
    }

    getCASEnabled(): Observable<string> {
        return this.http.get<string>(this.baseUrl + 'api/core/configuration/CASEnabled').pipe();
    }

    getCopyrightYear(): Observable<number> {
        return of(this.currentYear);
    }

    getArrobaClaveEnabled(): Observable<string> {
        if (this.arrobaClaveEnabled !== null) {
            return of(this.arrobaClaveEnabled);
        }
        return this.http.get<string>(this.baseUrl + 'api/core/configuration/ArrobaClaveEnabled').pipe(
            tap(res => {
                this.arrobaClaveEnabled = res;
            }),
        );
    }

    getTestingEnabled(): Observable<string> {
        if (this.testingEnabled !== null) {
            return of(this.testingEnabled);
        }
        return this.http.get<string>(this.baseUrl + 'api/core/configuration/TestingEnabled').pipe(
            tap(res => {
                this.testingEnabled = res;
            }),
        );
    }

    get limitsDocSize(): MegaSizeLimitViewModel {
        return this._limitsDocSize;
    }
    set limitsDocSize(limitsDocSize: MegaSizeLimitViewModel) {
        this._limitsDocSize = limitsDocSize;
    }
}
